const var_name = [
  {
    id: 52,
    name: "VIP Seating",
  },
  {
    id: 53,
    name: "Seating C",
  },
];

export { var_name };
